import { createContext } from "react";

const PortfolioContext = createContext({
	userViews					: [],
	setUserViews				: () => {},
	allFields					: [],
	setAllFields				: () => {},
	convertToDollar				: false,
	setConvertToDollar			: () => {},
	analyzeQuarterly			: false,
	setAnalyzeQuarterly			: () => {},
	allowFailedRiskGrowth		: false,
	setAllowFailedRiskGrowth	: () => {},
	investmentIntervalDays		: 0,
	setInvestmentIntervalDays	: () => {},
	investByDate				: false,
	setInvestByDate				: () => {},
})

export default PortfolioContext
